export const getApplications = (id = '') => ({ method: 'GET', url: `/v3/applications/${id}` })

export const getPages = (jobRoleId, code) => ({
  method: 'GET',
  url: `/configuration/page?jobRoleId=${jobRoleId}&pageCode=${code}`
})
